<template>
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <rect
            x="15.6667"
            y="4.33339"
            width="5.73333"
            height="15.3333"
            rx="0.333333"
            transform="rotate(90 15.6667 4.33339)"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="0.666667" />
        <rect
            x="15.6667"
            y="12.3334"
            width="2.53333"
            height="15.3333"
            rx="0.333333"
            transform="rotate(90 15.6667 12.3334)"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="0.666667" />
        <rect
            x="15.6667"
            y="17.1341"
            width="0.933334"
            height="15.3333"
            rx="0.333333"
            transform="rotate(90 15.6667 17.1341)"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="0.666667" />
    </svg>
</template>
